/**
 * Unified Error Notification Utilities
 * Issue #2058: エラーハンドリング・伝搬パターンの統一
 *
 * 既存の error.ts を再利用した薄いブリッジ。
 * alert() の代わりに sonner toast を使う統一的な通知API。
 */

import { toast } from 'sonner';
import { handleError, logError, shouldDisplayToUser, shouldLogoutOnError, EnhancedApiError, ErrorSeverity } from './error';

/**
 * エラーを処理して適切に通知する
 * - EnhancedApiError に変換
 * - ログ出力
 * - ユーザー表示が必要かつログアウト対象でない場合のみ toast.error
 * @param error - 任意のエラーオブジェクト
 * @param context - ログに含めるコンテキスト文字列
 * @param customMessage - toast に表示するカスタムメッセージ（省略時は enhanced.userMessage を使用）
 */
export function notifyError(error: unknown, context?: string, customMessage?: string): EnhancedApiError {
  const enhanced = handleError(error);
  logError(enhanced, context ? { context } : undefined);
  // CRITICALセキュリティエラー（TENANT_ACCESS_VIOLATION等）はtoast表示せずログのみ
  const isCriticalSecurity = enhanced.severity === ErrorSeverity.CRITICAL;
  if (!isCriticalSecurity && !shouldLogoutOnError(enhanced) && shouldDisplayToUser(enhanced)) {
    toast.error(customMessage || enhanced.userMessage);
  }
  return enhanced;
}

export function notifySuccess(message: string) { toast.success(message); }
export function notifyWarning(message: string) { toast.warning(message); }
export function notifyInfo(message: string) { toast.info(message); }
